import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import AdministrativeTransactionRequest from "../../../../interfaces/adminRequests/AdministrativeTransactionRequest";
import { useAuth } from "../../../../firebase/AuthProvider";
import OwnerDashboardElement from "./OwnerDashboardElement";
import OwnerInboxElement from "./OwnerInboxElement";
import OwnerAnalyticsElement from "./OwnerAnalyticsElement";
import OwnerReportsElement from "./OwnerReportsElement";
import OwnerSettingsElement from "./OwnerSettingsElement";
import AddUser from "../../userComponents/UserManagement/AddUser";
import EditUser from "../../userComponents/UserManagement/EditUser";
import ChangePassword from "../../userComponents/UserManagement/ChangePassword";
import MyCalendar from "../../calendar/MyCalendar";
import AdminRequests from "../../adminRequests/AdminRequests";
import Avatar from "../../../../interfaces/avatar/Avatar";
import { getAvatarsFromStorage } from "../../../../services/fileServices/FileService";
import EditRecurringTasksPage from "../../task/taskEdit/EditRecurringTasksPage";
import EditParticipantPage from "../../participants/EditParticipantPage";
import CreateParticipantPage from "../../participants/CreateParticipantPage";
import EditTemplateInterimTasks from "../../task/taskEdit/EditTemplateInterimTasks";
import EditTemplateFiles from "../../templateFiles/EditTemplateFiles";
import CreateNewTaskActivityPage from "../../taskActivity/CreateNewTaskActivityPage";
import SuggestionRulesComponent from "../../generatedSuggestions/SuggestionRulesComponent";
import TagList from "../../task/tagCreation/TagList";
import OwnerParticipantsElement from "./OwnerParticipantsElement";
import TriggerEmergencySurveyOneAndThree from "./TriggerPoststormsurvey/TriggerEmergencySurveyOneAndThree";
import TeamDashboard from "../../teamPage/TeamDashboard";
import JustificationReason from "../../workflow/JustificationReason";
import OwnerHome from "../../ownerhome/OwnerHome";
import Budgetoverview from "../../budgetoverview/Budgetoverview";
import { QepPage } from "../../qep/QepPage";
import MeetingInvite from "../../qep/qeptabs/MeetingInvite";
import TaskExclusion from "../../TaskExclusion/TaskExclusion";
import ParticipantResourcePage from "../../participant-Resource/ParticipantResourcePage";
import AddParticipantResource from "../../participant-Resource/AddParticipantResource";
import EditParticipantResource from "../../participant-Resource/EditParticipantResource";
import ParticipantServiceDefinitionPage from "../../participantServiceDefinition/ParticipantServiceDefinitionPage";
import AddParticipantServiceDefiniton from "../../participantServiceDefinition/AddParticipantServiceDefiniton";
import EditParticipantServiceDefinition from "../../participantServiceDefinition/EditParticipantServiceDefinition";
import OnwerHomeNew from "../../OwnerhomeNew/OnwerHomeNew";
import Holiday from "../../Holiday/Holiday";

export default function OwnerRoutes() {
  const { currentUser, currentRoles } = useAuth();
  const [avatars, setAvatars] = useState<Avatar[] | null>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const storedAvatars = getAvatarsFromStorage();
    setAvatars(storedAvatars);
  }, []);

  const getAuthToken = async () => {
    // 1. Use 'await' inside the async function to get the token
    const token = await currentUser?.getIdToken();

    // 2. Log the token after it's successfully retrieved
    console.log("OWNER AUTH", token);

    // 3. Return the token if needed by the calling function
    return token;
  };
  getAuthToken();

  useEffect(() => {
    if (
      currentRoles &&
      currentRoles.some((role) => {
        return role.name === "OWNER" || role.name === "ADMIN";
      })
    ) {
      return;
    } else {
      navigate("/home");
    }
  }, [currentRoles]);
  return (
    <>
      <Routes>
        {/* <Route path="team/old" element={<OwnerDashboardElement />} /> */}
        {/* <Route path="" element={<OwnerHome />} /> */}
        <Route path="" element={<OnwerHomeNew />} />
        <Route path="inbox" element={<OwnerInboxElement />} />
        <Route path="analytics" element={<OwnerAnalyticsElement />} />
        <Route path="participants" element={<OwnerParticipantsElement />} />
        <Route path="reports" element={<OwnerReportsElement />} />
        <Route path="settings" element={<OwnerSettingsElement />} />
        {/* <Route path="addUser" element={<AddUser />} /> */}
        <Route path="EditUser/:userId" element={<EditUser />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="calendar" element={<MyCalendar />} />
        <Route path="requests" element={<AdminRequests />} />
        <Route
          path="edit/task/recurring/*"
          element={<EditRecurringTasksPage />}
        ></Route>
        <Route
          path="/edit/participants/*"
          element={<EditParticipantPage />}
        ></Route>
        <Route
          path="/edit/participants/new"
          element={<CreateParticipantPage />}
        ></Route>
        <Route
          path="/edit/interims/*"
          element={<EditTemplateInterimTasks />}
        ></Route>
        <Route
          path="/edit/templateFiles/*"
          element={<EditTemplateFiles />}
        ></Route>
        <Route
          path="/task/edit/activity/template"
          element={<CreateNewTaskActivityPage />}
        ></Route>
        <Route
          path="/edit/suggestionRules/*"
          element={<SuggestionRulesComponent />}
        ></Route>
        <Route path="/tags" element={<TagList />} />
        <Route
          path="/trigger/emergencysurvey/:surveyname"
          element={<TriggerEmergencySurveyOneAndThree />}
        />
        <Route path="/team" element={<TeamDashboard />} />
        <Route
          path="/workflow/justification"
          element={<JustificationReason />}
        />
        <Route
          path="/workflow/justification"
          element={<JustificationReason />}
        />
        <Route path="/ownerhome" element={<OwnerHome />} />
        <Route path="/budgetoverview" element={<Budgetoverview />} />
        <Route path="/taskexclusion" element={<TaskExclusion />} />
        {/* qep routes */}
        <Route path="/qep" element={<QepPage />} />
        <Route path="/qep/meetinginvite" element={<MeetingInvite />} />
        {/* qep routes */}

        {/* Resource Routes */}
        <Route path="/resources" element={<ParticipantResourcePage />} />
        <Route path="/resources/Add" element={<AddParticipantResource />} />
        <Route
          path="/resources/Edit/:participantResourceId"
          element={<EditParticipantResource />}
        />

        {/* Resource Routes */}

        {/* Service Route */}
        <Route
          path="/service-definition"
          element={<ParticipantServiceDefinitionPage />}
        />
        <Route
          path="/service-definition/Add"
          element={<AddParticipantServiceDefiniton />}
        />
        <Route
          path="/service-definition/Edit/:serviceId"
          element={<EditParticipantServiceDefinition />}
        />

        {/* Service Route */}
              <Route
                  path="/holiday"
                  element={<Holiday />}
              />

      </Routes>
    </>
  );
}
